import { useEffect } from "react";

const setMetaTag = (name, content) => {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  if (!href) return;
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const usePageMeta = ({ title, description, canonical }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    setMetaTag("description", description);
    setCanonical(canonical);
  }, [title, description, canonical]);
};

export default usePageMeta;
